import { Role } from './models/Role';

export const downloadHandler = (data: any, fileName: string): void => {
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const removeTimezoneOffset = (date: Date): Date => new Date(date.getTime() - date.getTimezoneOffset() * 60000);

export function getEnumKeys<T extends string, TEnumValue extends string | number>(enumVariable: { [key in T]: TEnumValue }) {
  return Object.keys(enumVariable) as Array<T>;
}

export function convertDate(regdate: string) {
  return new Date(regdate.replace(/(\d+[/])(\d+[/])/, '$2$1'));
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const convertToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });

export const bulkUploadImages = async (files: File[]): Promise<string[]> => {
  const images = await Promise.all(
    files.map(async file => {
      const base64 = await convertToBase64(file);
      return typeof base64 === 'string' ? base64 : '';
    })
  );
  return images.filter(Boolean);
};

export const isRoleHighEnough = (roles: Role[], requiredRole: Role): boolean => {
  const rolesHierarchy = [
    Role.Viewer,
    Role.Editor,
    Role.Valuer,
    Role.CAdministrator,
    Role.GAdministrator,
    Role.Administrator,
  ];
  const requiredRoleIndex = rolesHierarchy.indexOf(requiredRole);
  return roles.some(role => rolesHierarchy.indexOf(role) >= requiredRoleIndex);
};
